module.exports = __webpack_public_path__ + "static/mw5-eacadf1218ad30b50141d3c5707271fc.jpg";